import Icon from '@/components/snippets/icon/icon'
import { useFormInput } from '../hooks/useFormInput'
import { RelativeModal } from './RelativeModal'
import { FieldText } from './FieldText'
import { useToggle } from '../hooks/useToggle'
import { useAccountLayoutContext } from './AccountProfileContext'
import LoaderSpin from '@/components/snippets/loader-spin/loader-spin'
import { useState } from 'preact/hooks'
import { getAllWishlists } from '../helpers/getAllWishlists'
import { accountTranslations } from '../helpers/translations'
export const WishlistRelativeModal = ({ handleRefetch, title, wishlist, buttonTitle }) => {
  const [isFetching, setIsFetching] = useState(false)
  const { isActive, handleToggle } = useToggle()
  const { omneoClient } = useAccountLayoutContext()
  const { formInputs, handleOnChange } = useFormInput({
    name: wishlist?.name ?? ''
  })

  /**
   * Handles the delete callback for a list. On success the page will trigger a reload.
   * @returns {Promise<void>}
   */
  const handleDeleteWishlist = async () => {
    if (!wishlist?.id) return
    setIsFetching(true)
    await omneoClient.profileClient.removeWishlistById(wishlist.id)
    setIsFetching(false)
    handleToggle()
    window.location.reload()
  }

  /**
   * Handles the create or update callback for the account wishlist
   * @param {*} e
   * @returns {Promise<void>}
   */
  const handleFormSubmit = async (e) => {
    e.preventDefault()
    setIsFetching(true)
    if (wishlist?.id) {
      await omneoClient.profileClient.updateWishlistById(wishlist.id, { name: formInputs.name.value })
    } else {
      await omneoClient.profileClient.createWishlist(formInputs.name.value)
    }
    setIsFetching(false)
    if (handleRefetch) {
      await getAllWishlists(omneoClient)
      handleRefetch()
    }
    handleToggle()
  }

  return (
    <RelativeModal right={true} isActive={isActive} handleToggle={handleToggle} title={buttonTitle}>
      <div className={'flex min-h-10 w-full min-w-fit flex-col border bg-white md:w-96'}>
        <div className={'flex w-full flex-row items-center justify-between border-b p-4'}>
          <h4 className={'h4 font-bold'}>{title}</h4>
          <div className={'cursor-pointer'} onClick={handleToggle}>
            <Icon id="close" />
          </div>
        </div>
        <form
          className={`px-4 py-2 transition-opacity ${isFetching ? 'pointer-events-none opacity-45' : ''}`}
          onSubmit={handleFormSubmit}
        >
          <FieldText
            required={true}
            label={accountTranslations.wishlist.list_name}
            name={formInputs.name.key}
            placeholder={accountTranslations.wishlist.list_name_placeholder}
            value={formInputs.name.value}
            onChange={handleOnChange}
          />
          <div className={'flex flex-row gap-2 pb-1 pt-4'}>
            <div
              onClick={async () => {
                if (wishlist?.id) {
                  await handleDeleteWishlist()
                  return
                }
                handleToggle()
              }}
              className={'btn btn-md btn-outline-black w-full'}
            >
              {wishlist?.id ? 'Delete wishlist' : 'Cancel'}
            </div>
            <button className={'btn btn-md btn-solid-black relative w-full overflow-hidden'}>
              {isFetching ? <LoaderSpin wrapperClass="bg-black" /> : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </RelativeModal>
  )
}
